import { Loader } from '@googlemaps/js-api-loader';

const element = document.querySelector('.js-map');

const loader = new Loader({
  apiKey: wordpress.googleApiKey,
  version: 'weekly',
  libraries: ['places'],
});

if (element) {
  loader.loadCallback(() => handleLoad());
}

const styles = [
  {
    featureType: 'administrative',
    elementType: 'all',
    stylers: [
      {
        saturation: '-100',
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: 65,
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: '50',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        saturation: '-100',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'all',
    stylers: [
      {
        lightness: '30',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'all',
    stylers: [
      {
        lightness: '40',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        hue: '#ffff00',
      },
      {
        lightness: -25,
      },
      {
        saturation: -97,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [
      {
        lightness: -25,
      },
      {
        saturation: -100,
      },
    ],
  },
];

function handleLoad() {
  //

  const position = {
    lat: Number(element.getAttribute('data-lat')),
    lng: Number(element.getAttribute('data-lng')),
  };

  const map = new google.maps.Map(element, {
    center: position,
    clickableIcons: false,
    styles,
    zoom: 17,
  });

  const icon = {
    path: `M21.5 0A21.46 21.46 0 0 0 6.314 6.371 21.85 21.85 0 0 0 0 21.694c0 11.544 19.528 38.54 20.418 39.711L21.6 63l1.082-1.695C23.472 60.234 43 33.238 43 21.694A21.853 21.853 0 0 0 36.686 6.37 21.46 21.46 0 0 0 21.5 0zm.1 31.055a9.214 9.214 0 0 1-6.544-2.735 9.38 9.38 0 0 1-2.711-6.603c0-2.477.975-4.852 2.711-6.604 1.736-1.751 4.09-2.735 6.544-2.735s4.809.984 6.544 2.735a9.38 9.38 0 0 1 2.711 6.604 9.378 9.378 0 0 1-2.711 6.603 9.22 9.22 0 0 1-6.544 2.735z`,
    fillColor: '#005a65',
    fillOpacity: 1,
    strokeWeight: 0,
    anchor: new google.maps.Point(43 / 2, 63), // anchor
  };

  const marker = new google.maps.Marker({ position, map, icon });
}
